import { HearingShell } from '@/components/HearingShell';
import { useMatters } from '@/contexts/MatterContext';

export function Hearing() {
  const { activeMatterId } = useMatters();
  return <HearingShell matterId={activeMatterId} />;
}
